// Texto colado nos dados da procuração (CPF/CNPJ) e do contrato entra em
// MAIÚSCULAS (pedido do Vagner, 02/10/2026). Quebras de linha e espaços
// sobrando do texto copiado viram um espaço só. O insertText mantém o cursor
// e o Ctrl+Z e dispara o onChange normal do campo.
export function colarEmMaiusculas(e) {
  const texto = e.clipboardData?.getData('text') || '';
  const maiusculo = texto.replace(/\s+/g, ' ').trim().toLocaleUpperCase('pt-BR');
  if (!maiusculo || maiusculo === texto) return; // nada a mudar: colagem normal
  e.preventDefault();
  if (document.execCommand('insertText', false, maiusculo)) return;
  // Navegador sem insertText: monta o valor e avisa o React como se fosse digitação
  const el = e.target;
  const ini = el.selectionStart ?? el.value.length;
  const fim = el.selectionEnd ?? el.value.length;
  const setValor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  setValor.call(el, el.value.slice(0, ini) + maiusculo + el.value.slice(fim));
  el.dispatchEvent(new Event('input', { bubbles: true }));
  el.setSelectionRange(ini + maiusculo.length, ini + maiusculo.length);
}
